<template>
  <div class="main-container">
    <div class="main-container__news">
      <div
        @click="goToDetail(index)"
        v-for="(item,index) in this.newsData"
        :key="item.title"
        class="main-container__new"
      >
        <div class="main-container__image">
          <img :src="getAbsoluteImageUrl(item.image)" />
        </div>
        <div class="main-container__new__text">
          <div class="main-container__new__text__title">
            <h1>{{ item.title}}</h1>
          </div>
          <div class="main-container__new__text__desc">
            <p v-if="!this.isMobile">
              {{ removeHtmlTags(item.body, 280) }}
            </p>
            <p v-if="this.isMobile">
              {{ removeHtmlTags(item.body, 160) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="main-container__title">
      <div class="main-container__title__pagination">
        <Pagination
          :page="this.newsPages.current_page + 1"
          :totalPages="this.newsPages.total_pages"
          @change-value="onChangeValue"
        ></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNews } from "@/utils/endpoint";
import Pagination from "@/components/PaginationComponent.vue";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      newsData: [],
      actualPage: 1,
      newsPages: {},
      isMobile: false,
    };
  },
  mounted() {
    this.getNewsData(0);
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUpdate() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    async getNewsData(page) {
      await getNews(page).then((res) => {
        this.newsData = res.data.rows;
        this.newsPages = res.data.pager;
      });
    },
    extractTextFromHtml(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const anchorTag = doc.querySelector("a");
      return anchorTag ? anchorTag.textContent : "";
    },
    extractNodeIdFromHref(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const anchorTag = doc.querySelector("a");

      if (anchorTag) {
        const href = anchorTag.getAttribute("href");
        const nodeId = href.match(/\/(\d+)$/);
        return nodeId ? nodeId[1] : null;
      }
      return null;
    },
    formattedTitle(val) {
      // Use DOMParser to parse the HTML string
      const parser = new DOMParser();
      const doc = parser.parseFromString(val.title, "text/html");

      // Find the anchor tag in a safer way
      const anchorTag = doc.querySelector("a");

      if (anchorTag) {
        // Get the existing href attribute
        const href = anchorTag.getAttribute("href");

        // Assuming the base URL is 'https://cms.lloret.cat'
        const completeUrl = `https://cms.lloret.cat${href}`;

        // Set the modified href attribute
        anchorTag.setAttribute("href", completeUrl);

        // Return the updated HTML string
        return doc.body.innerHTML;
      }

      // If no anchor tag is found, return the original HTML string
      return val.title;
    },
    goToDetail(index) {
      // const nid = this.extractNodeIdFromHref(val.title);

      this.$router.push(`/detail/${this.newsPages.current_page}/${index}`);
    },
    removeHtmlTags(html, maxLength = 80) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const textContent = (doc.body.textContent || "").trim(); // Eliminar espacios al inicio y al final

      // Truncate the content if it exceeds maxLength
      const truncatedContent =
        textContent.length > maxLength
          ? textContent.slice(0, maxLength - 3) + "..." // Agregar puntos suspensivos
          : textContent;

      return truncatedContent;
    },

    getAbsoluteImageUrl(html) {
      const relativeSrc = this.extractSrcFromHtml(html);
      if (relativeSrc) {
        const baseUrl = "https://cms.lloret.cat/";
        return `${baseUrl}${relativeSrc}`;
      }
      return null;
    },
    extractSrcFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const imgElement = doc.querySelector("img");
      return imgElement ? imgElement.getAttribute("src") : null;
    },
    async onChangeValue(value) {
      this.newsPages.current_page = value;
      await this.getNewsData(value - 1);
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  watch: {
    // Watch for window resize events and update isMobile accordingly
    $: {
      handler() {
        this.checkScreenSize();
      },
      immediate: true, // Fire the handler immediately on component creation
    },
  },
};
</script>
<style scoped>
.main-container {
  margin: 0 auto;
  width: 85%;
}

.main-container__image {
  width: 300px;
  height: 255px;
}

.main-container__image img {
  width: 300px;
  height: 100%;
}

.main-container__desc {
  margin-bottom: 20px;
}

.main-container__desc h2 {
  margin-bottom: 20px;
  color: #00766f;
}

.main-container__image__main img {
  height: 800px;
  width: 200px;
  object-fit: cover;
}

.main-container__new {
  margin-top:5px;
  display: flex;
  align-items: flex-end;
  justify-content: left;
  margin-bottom: 40px;
  box-shadow: 0 0 10px 0 gray;
}

.main-container__new:hover {
  cursor: pointer;
}

.main-container__new__text {
  height: 240px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 10px;
}

.main-container__new__text__title {
  background-color: #e7e7e7;
  padding: 10px;
  color: #00776e !important;
  text-decoration: none;
}

.main-container__new__text__title h1 {
  pointer-events: none;
  text-decoration: none;
  color: #00776e;
}

.main-container__new__text__desc {
  margin-bottom: 20px;
  text-align: left;
}

.main-container__new__text__date {
  padding-bottom: 10px;
}

.main-container__title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-container__title__text {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
}

.main-container__title__pagination {
  width: 60%;
}

.main-container__title h3 {
  margin-right: 10px;
  color: #00766f;
}

.main-container__title .icon {
  color: #00766f;
}

@media (max-width: 1250px) {
  .main-container__new__text {
  }

  .main-container__new__text__desc {
    max-height: 180px;
    overflow: auto;
  }
  .main-container__new__text__title {
    font-size: 12px;
    color: #00776e !important;
    text-decoration: none;
  }
}

@media (max-width: 1024px) {
  .main-container__new__text__title {
    font-size: 12px;
    color: #00776e !important;
    text-decoration: none;
  }
}

@media (max-width: 768px) {
  .main-container__new__text__title {
    color: #00776e !important;
    text-decoration: none;
  }
}

@media (max-width: 480px) {
  .main-container__new__text__title {
    color: #00776e !important;
    text-decoration: none;
  }

  .main-container__new {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .main-container__image {
    background: red;
    height: 180px;
    width: 100%;
  }

  .main-container__image img {
    width: 100%;
    height: 100%;
  }
}
</style>
